import React, { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';

import EventContext from './EventContext';

const EventProvider = ({ children }: PropsWithChildren<any>) => {
  // @ts-ignore
  const reduxState = useSelector((state) => state.preferences.selectedEvent?.id ? state.preferences.selectedEvent : null);

  return <EventContext.Provider value={reduxState}>{children}</EventContext.Provider>;
};

export default EventProvider;
